import { render, staticRenderFns } from "./TabletLayout.vue?vue&type=template&id=626c4cb9&scoped=true&"
import script from "./TabletLayout.vue?vue&type=script&lang=js&"
export * from "./TabletLayout.vue?vue&type=script&lang=js&"
import style0 from "./TabletLayout.vue?vue&type=style&index=0&id=626c4cb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626c4cb9",
  null
  
)

export default component.exports